import { Injectable } from '@angular/core';
import {
  getFirestore,
  collection,
  doc,
  setDoc,
  deleteDoc,
  onSnapshot,
} from 'firebase/firestore';
import { from, Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { COLLECTION_MEDICATIONS } from '../global';
import { Medication } from '../models/medication.model';

@Injectable({
  providedIn: 'root',
})
export class MedicationService {

  getAllMedications() {
    const db = getFirestore();
    return new Observable<any>((observer) =>
      onSnapshot(collection(db, COLLECTION_MEDICATIONS),
        (snapshot) => observer.next(snapshot.docChanges().map((change) => ({ payload: change }))),
        (error) => observer.error(error)
      )
    );
  }

  getMedication(medicationId: string) {
    const db = getFirestore();
    return new Observable<any>((observer) =>
      onSnapshot(doc(db, COLLECTION_MEDICATIONS, medicationId),
        (snapshot) => observer.next({ payload: snapshot }),
        (error) => observer.error(error)
      )
    );
  }

  static getMedicationFromSnapshot(snapshot: any): Medication {
    const medication = new Medication();
    const obj = {
      id: snapshot.payload.id,
      ...(snapshot.payload.data() as object),
    };
    Object.assign(medication, obj);
    return medication;
  }

  upsertMedication(med: Medication) {
    this.cleanMedData(med);
    const obj = this.extractMedData(med);
    const db = getFirestore();
    return from(setDoc(doc(db, COLLECTION_MEDICATIONS, med.id), obj));
  }

  deleteMedication(id: string) {
    const db = getFirestore();
    return from(deleteDoc(doc(db, COLLECTION_MEDICATIONS, id))).pipe(take(1));
  }

  private extractMedData(med: Medication): object {
    const obj = JSON.parse(JSON.stringify(Object.assign({}, med)));
    delete obj.id;
    return obj;
  }

  private cleanMedData(med: Medication) {
    med.id = med.id.replace(/\s/g, '');
    med.name = med.name.trim();
    med.routes.forEach((route) => route.trim());
  }
}
